import { render, staticRenderFns } from "./RootCategoryDetail.vue?vue&type=template&id=00d51117&scoped=true&"
import script from "./RootCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./RootCategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d51117",
  null
  
)

export default component.exports